import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { CreateApplicationModal } from "./CreateApplicationModal";

const fabStyle = {
  position: "absolute",
  top: 80,
  right: 16,
};

export function CreateApplicationFab() {
  const [show, setShow] = useState(false);
  return (
    <>
      <Fab
        size="small"
        color="primary"
        aria-label="add"
        sx={fabStyle}
        onClick={() => setShow(true)}
      >
        <AddIcon />
      </Fab>
      <CreateApplicationModal onClose={() => setShow(false)} open={show} />
    </>
  );
}
